import { useState } from "react";
import { Image } from "antd";

const GalleryBlock = ({ images = [] }) => {
  const [active, setActive] = useState(0);

  if (!images.length) return null;

  return (
    <div
      style={{
        display: "flex",
        gap: 10,
        padding: 10,
        height: 260, // parent height that controls thumbnail scroll area
        alignItems: "stretch", // ensure children fill height
      }}
    >
      {/* Main Image */}
      <div
        style={{
          flex: 1,
          borderRadius: 12,
          overflow: "hidden",
          height: "100%",
          boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
        }}
      >
        <Image
          src={images[active]}
          alt="Product Image"
          width="100%"
          height="100%"
          style={{ objectFit: "cover" }}
          preview={false}
        />
      </div>

      {/* Vertical Thumbnails */}
      <div
        style={{
          width: 80,
          height: "100%",        // <== fill the parent's height so overflow can work
          display: "flex",
          flexDirection: "column",
          gap: 8,
          overflowY: "auto",     // scroll will appear when needed
          paddingRight: 4,
          boxSizing: "border-box",
        }}
      >
        {images.map((img, idx) => (
          <div
            key={idx}
            onClick={() => setActive(idx)}
            style={{
              width: 70,
              height: 70,
              borderRadius: 10,
              overflow: "hidden",
              cursor: "pointer",
              border: idx === active ? "2px solid #4F46E5" : "2px solid transparent",
              flex: "0 0 auto", // prevent thumbnails from stretching
            }}
          >
            <Image
              src={img}
              alt="Thumbnail"
              width={70}
              height={70}
              style={{ objectFit: "cover", display: "block" }}
              preview={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryBlock;
